// import { WelcomeHeader } from "../welcomeHeader";
import React from 'react';
// import { WelcomeFooter } from "../welcomeFooter";
import { LeftContainer } from "./leftContainer";
import styles from "./guestpage.module.scss";
import { RightContainer } from "../guestPage/rightContainer/rightcontainer";
import logos from "../styles/images/ccasslogo.svg";

type GuestPageProps = {
  participantType: string;
}
export const GuestPage = ({ participantType }: GuestPageProps) => {
  return (
  <>
  {/* <WelcomeHeader></WelcomeHeader> */}
  <div className="customerheader">
        <img src={logos} />
      </div>
    <div className={styles.meetingDetails}>
      <LeftContainer></LeftContainer>
      <RightContainer participantType={participantType}></RightContainer>

    </div>
  <div className="customerfooter">
    <p>© Worktual 2024, All Rights Reserved</p>
    </div>
    {/* <WelcomeFooter></WelcomeFooter> */}
  </>);
};